import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaLiveSDK } from './types';
import { assert } from '../../assert';

const liveSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaLiveSDK
> = ({ setProps, props }) => ({
  get live() {
    return props.ariaAttributes?.live;
  },

  set live(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        live: assert.isNil(value) ? undefined : value,
      },
    });
  },
});

export const createLiveSDK = withValidation(liveSDKFactory, {
  type: ['object'],
  properties: {
    live: {
      type: ['string'],
      enum: ['polite', 'assertive'],
    },
  },
});
